<template>
  <g fill-rule="evenodd">
    <path
      d="M12.33 5.15a1.82 1.82 0 10-.16 3.62 1.82 1.82 0 00.16-3.61zM11.25 9.6H9.46c-.13 0-.26.02-.38.05a.37.37 0 00-.3.31c-.04.17.05.35.2.42.2.09.4.14.62.16.55.03.78.27.7.84-.16 1.07-.37 2.13-.55 3.2-.13.72-.23 1.44-.35 2.16-.15.97.75 1.88 1.47 2 .42.06.85.1 1.28.09.92 0 1.8-.39 2.43-1.06.12-.1.2-.23.25-.38a.47.47 0 00-.08-.37.36.36 0 00-.32-.03c-.16.05-.3.16-.47.23-.18.09-.38.16-.58.2a.57.57 0 01-.7-.5 1.93 1.93 0 01-.02-.57c.07-.46.16-.92.25-1.38.22-1.26.46-2.51.69-3.77.06-.34.17-.68.1-1.04a.6.6 0 00-.64-.56h-1.81zM12 2A10 10 0 112 11.99v-.02A10 10 0 0112.01 2z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "InfoIcon",
});
</script>
